import { EndpointFilterBaseDataProvider } from './EndpointFilterBaseDataProvider';
import { getRequestDefaultOptions } from '../../../utils/request.utils';
import { sanitizeObject } from '../../../utils/sanitization.utils';
import { GetEndpointsRequest, GetEndpointsResponse } from '@nirvana/shared/dtos/types/protected-entities/gz-console';

export class EndpointFilterGzDataProvider extends EndpointFilterBaseDataProvider {
  async getEndpoints(request: GetEndpointsRequest): Promise<GetEndpointsResponse | undefined> {
    try {
      const response = await this.dependencies.api.clients.Endpoints.getCompanyEndpoints(
        {
          companyId: request.companyId,
          endpointIds: request.endpointIds,
          endpointName: request.endpointName,
        },
        getRequestDefaultOptions()
      ).toPromise();

      return sanitizeObject(response);
    } catch (e) {
      throw new Error(e.message || e);
    }
  }
}
